"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Order = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M16,8 L7,8 L5,19 L18,19 L16,8 Z M8,7 L8,6 C8,4.34314575 9.56700338,3 11.5,3 C13.4329966,3 15,4.34314575 15,6 L15,7 L16,7 C16.4935711,7 16.9133207,7.36011113 16.9883717,7.84794282 L18.9883717,18.8479428 C19.0723506,19.3938054 18.6979198,19.9043928 18.1520572,19.9883717 C18.1185133,19.9935323 13.7344942,19.9974084 5,20 C4.44771525,20 4,19.5522847 4,19 C4,18.9660614 4.67054277,15.2487091 6.0116283,7.84794282 C6.08667933,7.36011113 6.50642892,7 7,7 L8,7 Z M9,7 L14,7 L14,6 C14,4.93258279 12.9119867,4 11.5,4 C10.0880133,4 9,4.93258279 9,6 L9,7 Z" })));
};
Order.displayName = 'Order';
exports.default = Order;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Order.js.map